import React from "react";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useFieldsScreenVM } from "@screens/FieldsScreen/FieldsScreenVM";
import { useLang } from "@src/hooks/useLang";
import { spectralLegend } from "@screens/FieldsScreen/spectralLegend";

const Root = styled.div`
  position: absolute;
  inset: 18px 16px auto auto;
  background: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  z-index: 2;
  width: 140px;
`;

const Title = styled.div`
  font-family: Nunito Sans, sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #899093;
  margin-bottom: 6px;
`;

const GradientBar = styled.div<{ gradient: string }>`
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(to right, ${({ gradient }) => gradient});
`;

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 3px;
  font-family: Nunito Sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #494c5b;
`;

const DateInfo = styled.div`
  margin-top: 8px;
  font-family: Nunito Sans, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #494c5b;
`;

const MapNdviLegend: React.FC = () => {
  const vm = useFieldsScreenVM();
  const lang = useLang();

  if (!vm.isSpectralView(vm.selectedFieldView) || vm.selectedFieldId == null) return null;
  if (!vm.ndviSelectedDate) return null;

  const legend = spectralLegend(vm.spectralLayer, lang);

  const d = new Date(vm.ndviSelectedDate + "T00:00:00");
  const dateStr = d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <Root>
      <Title>{legend.title}</Title>
      <GradientBar gradient={legend.gradient} />
      <Labels>
        {legend.labels.map((l, i) => (
          <span key={i}>{l}</span>
        ))}
      </Labels>
      <DateInfo>{dateStr}</DateInfo>
    </Root>
  );
};

export default observer(MapNdviLegend);
